var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"type":"flex","justify":"end"}},[_c('common-back')],1)}
var staticRenderFns = []

export { render, staticRenderFns }